import _extends from "@babel/runtime/helpers/extends";
import { useIsMobileDimension, useIsTabletDimension } from '@beef/ui-kit';
import React from 'react';
import { mapStateToPaymentContainerProps } from "../PaymentContainer";
import { PaymentContainer } from "../PaymentContainer/PaymentContainer";
import { usePreventScrolling } from "./hooks/usePreventScrolling";
import { useTopUpState } from "./hooks/useTopUpState";

/**
 * Основной компонент пополнения баланса
 */
export var TopUpBalanceComponent = function TopUpBalanceComponent(props) {
  // Хуки для определения размера экрана
  useIsMobileDimension();
  useIsTabletDimension();
  usePreventScrolling(props.isOpen);

  // Управление состоянием
  var _useTopUpState = useTopUpState(props),
    getState = _useTopUpState.getState,
    setState = _useTopUpState.setState;

  // Рендер основного контейнера оплаты
  return /*#__PURE__*/React.createElement(PaymentContainer, _extends({}, mapStateToPaymentContainerProps(getState, setState), {
    "data-t-id": "components-Root"
  }));
};